import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-envelope",
  "use": "foquz-icon-envelope-usage",
  "viewBox": "0 0 19 14",
  "content": "<symbol viewBox=\"0 0 19 14\" fill=\"none\" id=\"foquz-icon-envelope\"><path d=\"M17.334 2.455c0-.8-.72-1.455-1.6-1.455h-12.8c-.88 0-1.6.655-1.6 1.455m16 0v8.727c0 .8-.72 1.454-1.6 1.454h-12.8c-.88 0-1.6-.654-1.6-1.454V2.455m16 0l-8 5.09-8-5.09\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol